<template>
    <div class="flex min-h-[600px] flex-1 flex-col items-center justify-center bg-white">
        <div v-if="loading" class="h-[200px] w-[200px]">
            <video x5-playsinline="true" playsinline="true" webkit-playsinline="true" :autoplay="true" :muted="true" poster="" loop="true" src="https://resource.auditoryworks.co/newNuroum/loading.mp4" x5-video-player-type="h5" x5-video-orientation="portraint" class="h-full w-full object-cover">
                <source src="https://resource.auditoryworks.co/newNuroum/loading.mp4" type="video/mp4" />
            </video>
        </div>
        <div v-else>
            <img class="mx-auto h-[100px] w-[100px] sm:h-[128px] sm:w-[128px]" :src="orderStatus.isSuccess ? 'https://resource.auditoryworks.co/lib/nearhub_success.png' : `${ossPath}/nearhub_failure.png`" alt="payment-result" />

            <div v-if="!loading" class="space-y-3">
                <p class="mb-4 mt-8 text-center text-4xl sm:text-6xl">{{ orderStatus.title }}</p>
                <p class="px-2 text-center text-xl lg:px-0">{{ orderStatus.content }}</p>
            </div>
        </div>
        <div v-if="orderInfo" class="mt-12 space-y-4 px-4 lg:px-0" label-position="left">
            <div label="Invoice">
                <div class="flex flex-col break-all sm:flex-row sm:gap-2"><span class="w-[130px] font-semibold">Invoice Number:</span> {{ orderInfo.invoiceNumber }}</div>
            </div>
            <div label="Total">
                <div class="flex flex-col break-all sm:flex-row sm:gap-2"><span class="w-[130px] font-semibold">Order Amount:</span> ${{ orderInfo.orderAmount }}</div>
            </div>
            <div label="Time">
                <div class="flex flex-col break-all sm:flex-row sm:gap-2"><span class="w-[130px] font-semibold">Order Time:</span> {{ orderInfo.transactionTime }}</div>
            </div>
            <!-- <div label="Time">
                <div v-if="status === 'COMPLETE'">Invoice： <WaLink :to=""></WaLink> </div>
            </div> -->
        </div>
    </div>
</template>
<script lang="ts" setup>
import { usePayment } from "@/utils/payment";
declare const washeng_tracking_v2: any;
const SUCCESS_PROCESS = ["SUCCESS", "PAID", "COMPLETE"];

const ossPath = "https://resource.auditoryworks.co/lib";
const loading = ref(true);
const orderInfo = ref<{
    invoiceNumber: string;
    orderAmount: string;
    transactionTime: string;
} | null>(null);
const status = ref();
const [payment_status, { initPayment, changeLocalConfig }] = usePayment();
// watch(
//     () => payment_status,
//     () => {
//         console.log("dsasdasdsdadasd", payment_status.status);
//     },
//     {
//         deep: true,
//         immediate: true,
//     }
// );

const msgMap = new Map();
msgMap.set("success", ["Payment Success!", "Please check your email for order updates and further details."]);
msgMap.set("fail", ["Payment Fail !", "Please check your designated email for  the payment failure notification or contact customer support for assistance."]);
msgMap.set("cancel", ["Payment Cancel", ""]);
msgMap.set("error", ["Payment Error", "An unknown error has occurred."]);

const orderStatus = computed(() => {
    const _status = status.value;
    const isSuccess = SUCCESS_PROCESS.includes(_status.toLocaleUpperCase());
    const [title, content] = msgMap.get(_status) || msgMap.get("error");
    return {
        isSuccess,
        title,
        content,
    };
});

const { locale, locales, localeProperties } = useI18n();
// 订单总价
onMounted(async () => {
    await initPayment(locale.value as any);
    let payment = (window as any).payment;
    await payment.init();
    loading.value = true;
    let { status: _status, sessionId } = payment.stripe.getOrderStatus();
    status.value = _status;
    if (!orderStatus.value.isSuccess) {
        loading.value = false;
        return;
    }
    const detail = await payment.stripe.getOrderInfo();
    const _orderInfo = {
        invoiceNumber: detail.invoiceNumber || "-",
        orderAmount: (detail.amount_total / 100).toFixed(2),
        transactionTime: formatTime(detail.created * 1000),
    };
    orderInfo.value = _orderInfo;
    loading.value = false;

    /** 为了解决重复上报的问题: 超过下单时间比较 1 小时后 肯定不重复上报数据 */
    if (detail.created) {
        const currentTime = new Date().getTime();
        if (currentTime - detail.created * 1000 > 1 * 60 * 60 * 1000) {
            return;
        }
    }
    if (window.sessionStorage.getItem(sessionId)) {
        return;
    }
    window.sessionStorage.setItem(sessionId, "1");
    gtag("event", "conversion", {
        send_to: "AW-11301612072/1SzhCIu7odMYEKjUg40q",
        value: _orderInfo.orderAmount,
        currency: "USD",
        transaction_id: sessionId,
    });
    gtag("event", "purchase", {
        transaction_id: sessionId,
        value: _orderInfo.orderAmount,
        currency: detail.currency || "usd",
        items: (detail.products?.data || []).map((item: any) => ({
            item_id: item.id,
            item_name: item.description,
            price: (item.amount_total / 100).toFixed(2),
            quantity: item.quantity,
        })),
    });
    window.fbq("track", "Purchase", { value: _orderInfo.orderAmount, currency: "USD" });
    // bing
    (window as any).uetq = (window as any).uetq || [];
    (window as any).uetq.push("set", {
        pid: {
            em: detail?.customer_details?.email, // Replace with the variable that holds the user's email address.
            ph: detail?.customer_details?.phone, // Replace with the variable that holds the user's phone number.
        },
    });
    (window as any).uetq = (window as any).uetq || [];
    (window as any).uetq.push("event", "purchase", { revenue_value: _orderInfo.orderAmount, currency: "USD" });
});
</script>
<style lang="scss"></style>
